import { render, staticRenderFns } from "./ReportContracts.vue?vue&type=template&id=165ce2f2"
import script from "./ReportContracts.vue?vue&type=script&lang=js"
export * from "./ReportContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports